<template lang="pug">
.container.is-fluid
    .columns
        .column.is-narrow
            p.title.t-1 Rosters
    .columns
        .column.is-3
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";

export default {
  name: "Rosters",
  components: {
    Sidebar
  }
};
</script>
